import styled from "@emotion/styled";
import { Typography } from "@kaltura/ds-react-components";

export const StyledBanner = styled("div")(({ theme }) => ({
    padding: theme.spacing(2),
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: theme.spacing(3),
    backgroundColor: theme.kaltura.palette.tone8,
}));

export const StyledMessage = styled(Typography)(({ theme }) => ({
    color: theme.kaltura.palette.tone1,
}));

export const StyledButtonsSection = styled("div")(({ theme }) => ({
    display: "flex",
    gap: theme.spacing(1),
}));
